/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-modules
const $ = require('@trello/jquery');
const { ModelLoader } = require('app/scripts/db/model-loader');
const BrowserWillBeUnsupportedView = require('app/scripts/views/header/browser-will-be-unsupported-view');
const InvitedBannerView = require('app/scripts/views/header/invited-banner-view');
const { ModelCache } = require('app/scripts/db/model-cache');
const AccountTransferRequiredBannerView = require('app/scripts/views/header/account-transfer-required-banner-view');
const ConfirmEmailBannerView = require('app/scripts/views/header/confirm-email-banner-view');
const {
  DowngradePeriodBannerView,
} = require('app/scripts/views/board-limits/DowngradePeriodBannerView');
const LoggedInPublicBoardBannerView = require('app/scripts/views/header/logged-in-public-board-banner-view');
const {
  OverdueBannerView,
} = require('app/scripts/views/header/OverdueBannerView');
const {
  getOverdueOrganization,
} = require('app/src/components/OverduePaymentBanner');
const PublicBoardBannerView = require('app/scripts/views/header/public-board-banner-view');
const SetPasswordBannerView = require('app/scripts/views/header/set-password-banner-view');
const TwoFactorBackupsBannerView = require('app/scripts/views/header/two-factor-backups-banner-view');
const TemplateBannerView = require('app/scripts/views/header/template-banner-view');
const PersonalBoardsOwnershipBanner = require('app/scripts/views/header/personal-boards-ownership-banner-view');
const FreeTrialBanner = require('app/scripts/views/header/free-trial-banner');
const NewLocaleBannerView = require('app/scripts/views/header/new-locale-banner-view');
const { Util } = require('app/scripts/lib/util');
const { Auth } = require('app/scripts/db/auth');
const {
  isBrowserSupported,
  isDesktop,
  isIos,
  isAndroid,
} = require('@trello/browser');
const { Analytics } = require('@trello/atlassian-analytics');
const _ = require('underscore');
const locales = require('@trello/locale').supportedLocales;
const { sendErrorEvent } = require('@trello/error-reporting');
const {
  currentModelManager,
} = require('app/scripts/controller/currentModelManager');
const {
  getLoggedOutHeaderExperiment,
  LoggedOutNavExperimentVariations,
} = require('app/src/components/LoggedOutHeader');

const needBackupCodes = function (member) {
  const twoFactorPrefs = member.getPref('twoFactor');
  return (
    (twoFactorPrefs != null ? twoFactorPrefs.enabled : undefined) &&
    twoFactorPrefs.needsNewBackups
  );
};

const showEnterpriseDeprovisioningBannerForEntity = (
  member,
  entity,
  idEnterprise,
  enterpriseStanding,
  pendingDeprovision,
  headerCache,
  topLevelView,
) => {
  // Dependency required at call site to avoid import cycles, do not lift to top of module
  const EnterpriseDeprovisioningBannerView = require('app/scripts/views/header/enterprise-deprovisioning-banner-view');
  const data = {
    displayName: entity.get('displayName'),
    idEnterprise,
    enterpriseStanding,
    pendingDeprovision,
    cid: entity.cid,
  };
  $('#banners').prepend(
    topLevelView(EnterpriseDeprovisioningBannerView, data, {
      modelCache: headerCache,
    }).render().el,
  );

  //record that the banner was shown for this user, so we don't show it again right away
  return member.recordEnterpriseDeprovisioningBannerShownFor(idEnterprise);
};

const showEnterpriseDeprovisioningBanner = (
  member,
  headerCache,
  topLevelView,
) => {
  // get the enterprises this member administers that we haven't displayed the
  // de-provisioning banner for recently
  const enterprises = member.enterpriseList.filter(
    (e) =>
      member.isEnterpriseAdminOf(e) &&
      member.shouldShowEnterpriseDeprovisioningBannerFor(e.id),
  );

  // load billing data asynchronously and display the banner if needed
  enterprises.forEach(function (enterprise) {
    //record that we checked if we needed to show the banner, so we don't check again right away
    member.recordEnterpriseDeprovisioningBannerCheckedFor(enterprise.id);
    return ModelLoader.loadEnterpriseStanding('enterprise', enterprise.id).then(
      ({ enterpriseStanding, pendingDeprovision }) => {
        if (enterpriseStanding > 0) {
          return showEnterpriseDeprovisioningBannerForEntity(
            member,
            enterprise,
            enterprise.id,
            enterpriseStanding,
            pendingDeprovision,
            headerCache,
            topLevelView,
          );
        }
      },
    );
  });

  // find bpco orgs this member administers that we haven't displayed the
  // de-provisioning banner for recently.
  let bcpoOrgs = member.organizationList.models.filter(
    (org) =>
      org.paysWithPurchaseOrder() &&
      (org.isBusinessClass() || org.isStandard()) &&
      org.ownedByMember(member) &&
      member.shouldShowEnterpriseDeprovisioningBannerFor(
        org.get('idEnterprise'),
      ),
  );
  bcpoOrgs = _.uniq(bcpoOrgs, (org) => org.get('idEnterprise'));

  // load billing data asynchronously and display the banner if needed
  return bcpoOrgs.forEach(function (org) {
    const idEnterprise = org.get('idEnterprise');
    //record that we checked if we needed to show the banner, so we don't check again right away
    member.recordEnterpriseDeprovisioningBannerCheckedFor(idEnterprise);
    return ModelLoader.loadEnterpriseStanding('organization', org.id).then(
      ({ enterpriseStanding, pendingDeprovision }) => {
        if (enterpriseStanding > 0) {
          return showEnterpriseDeprovisioningBannerForEntity(
            member,
            org,
            idEnterprise,
            enterpriseStanding,
            pendingDeprovision,
            headerCache,
            topLevelView,
          );
        }
      },
    );
  });
};

const showEnterpriseNotificationBanner = function (
  enterprise,
  headerCache,
  topLevelView,
  banner,
) {
  // Dependencies required at call site to avoid import cycles, do not lift to top of module
  const EnterpriseNotificationBannerView = require('app/scripts/views/header/enterprise-notification-banner-view');
  const { markdownAsHtml } = require('app/scripts/lib/markdown/format');

  let idSuffix = '';
  // Support for legacy HTML based banner, id was specific to the enterprise
  if (banner._id) {
    idSuffix = `-${banner._id}`;
  }

  const oneTimeMessageId = `enterprise-notification-banner-${enterprise.get(
    'id',
  )}${idSuffix}`;
  const alreadyExists = $('#banners').find(`.${oneTimeMessageId}`).length > 0;
  if (
    !alreadyExists &&
    banner.message &&
    !Auth.me().isDismissed(oneTimeMessageId)
  ) {
    // Support for legacy HTML based banner
    // Markdown banners will have an _id
    let formattedMessage = banner.message;

    if (banner._id) {
      // Markdown banners will have an _id
      formattedMessage = markdownAsHtml(banner.message);
    }

    const data = {
      id: enterprise.get('id'),
      displayName: enterprise.get('displayName'),
      message: formattedMessage,
      oneTimeMessageId,
    };
    return $('#banners').prepend(
      topLevelView(EnterpriseNotificationBannerView, data, {
        modelCache: headerCache,
      }).render().el,
    );
  }
};

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null
    ? transform(value)
    : undefined;
}

const showEnterpriseNotificationBanners = (member, headerCache, topLevelView) =>
  member.enterpriseList.forEach(function (enterprise) {
    const banners =
      __guard__(
        __guard__(enterprise.get('prefs'), (x1) => x1.notifications),
        (x) => x.banners,
      ) || [];
    const notification = __guard__(
      __guard__(enterprise.get('prefs'), (x3) => x3.notifications),
      (x2) => x2.banner,
    );
    if (notification) {
      banners.push({
        _id: null,
        message: notification,
      });
    }

    return banners.forEach((banner) =>
      showEnterpriseNotificationBanner(
        enterprise,
        headerCache,
        topLevelView,
        banner,
      ),
    );
  });

let hasFiredBrowserBannerEvent = false;

module.exports.renderBannerContent = function (selector) {
  let opts;
  const me = Auth.me();
  const headerCache = ModelCache;
  const container = $('#banners');

  const bannerLocales = _.chain(locales)
    .pluck('code')
    .filter((locale) => locale.indexOf('en') !== 0)
    .value();

  // See if we need to display a "your browser is old" message
  const showUnsupportedBanner = !isBrowserSupported() && !isDesktop();

  if (showUnsupportedBanner) {
    // We don't want to tell mobile device users to upgrade their browser because they often can't on older devices.
    // Also, there is an issue where some users are potentially seeing this banner when they shouldn't, so we'd like
    // to collect data on their user agent.
    const hideBanner = isIos() || isAndroid();

    // Make sure we only fire this event once per reload (rather than every time we call this function).
    if (hasFiredBrowserBannerEvent === false) {
      Analytics.sendOperationalEvent({
        action: hideBanner ? 'hid' : 'shown',
        actionSubject: 'banner',
        source: 'browserWillBeUnsupportedBanner',
        attributes: {
          userAgent: window?.navigator?.userAgent || 'unavailable',
        },
      });
      hasFiredBrowserBannerEvent = true;
    }

    if (!hideBanner) {
      container.append(
        this.topLevelView(BrowserWillBeUnsupportedView, me, {
          modelCache: headerCache,
        }).render().el,
      );
    }
  }

  // See if there are any important messages we'd like to convey to the user
  const currentModel = this.currentModel.get();
  if (currentModel && Util.hasValidInviteTokenFor(currentModel, Auth.me())) {
    opts = {
      modelCache: this.getCurrentModelCache(),
      idMemberAdder: Util.inviteTokenFor(currentModel.id).split('-')[1],
    };

    if (currentModelManager.onAnyBoardView()) {
      opts.idBoard = currentModel.id;
    } else if (currentModelManager.onAnyOrganizationView()) {
      opts.idOrganization = currentModel.id;
    }

    return container
      .append(
        this.topLevelView(InvitedBannerView, me, opts, currentModel.id).render()
          .el,
      )
      .toggleClass('personalized-invite', !Auth.isLoggedIn());
  } else {
    if (Auth.isLoggedIn()) {
      // Only show the banner to confirmed users
      let enterprise, locale, org;
      if (Auth.confirmed() && currentModel && this.getCurrentModelCache()) {
        try {
          const freeTrialBanner = this.topLevelView(
            FreeTrialBanner,
            currentModel,
            { modelCache: this.getCurrentModelCache() },
          ).render();
          container.append(freeTrialBanner.el);
        } catch (err) {
          sendErrorEvent(err, {
            tags: {
              ownershipArea: 'trello-mocha',
              feature: 'Free Trial Existing Team',
            },
            extraData: {
              component: 'renderBannerContent',
            },
          });
        }
      }

      if (currentModelManager.onAnyBoardView()) {
        // Show template banner even if another banner is showing but defer to
        // view for watching if board is a template, in the case where a board
        // is converted into a template.
        const templateBanner = this.topLevelView(
          TemplateBannerView,
          currentModel,
          { modelCache: this.getCurrentModelCache() },
        ).render();
        container.append(templateBanner.el);

        // Show logged in public board banner even if another banner is showing,
        // but defer to view for watching if board is public. This handles the case
        // when a board is private but becomes public.
        const publicBoardBanner = this.topLevelView(
          LoggedInPublicBoardBannerView,
          currentModel,
          { modelCache: this.getCurrentModelCache() },
        ).render();
        container.append(publicBoardBanner.el);

        // Show the downgrade banner on any board view, regardless of template or visibility
        const downgradeBanner = this.topLevelView(
          DowngradePeriodBannerView,
          currentModel,
          { modelCache: this.getCurrentModelCache() },
        ).render();
        container.append(downgradeBanner.el);
      }

      if (!Auth.confirmed()) {
        container.append(
          this.topLevelView(ConfirmEmailBannerView, me, {
            modelCache: headerCache,
          }).render().el,
        );
      } else if (!Auth.canLogIn()) {
        container.append(
          this.topLevelView(SetPasswordBannerView, me, {
            modelCache: headerCache,
          }).render().el,
        );
      } else if (
        (enterprise = Auth.me().get('enterpriseWithRequiredConversion')) &&
        !me.isAccountTransferBannerDismissed()
      ) {
        opts = {
          modelCache: headerCache,
          locale,
          enterprise,
        };
        container.append(
          this.topLevelView(
            AccountTransferRequiredBannerView,
            me,
            opts,
          ).render().el,
        );
      } else if (
        (enterprise = Auth.me().get('enterpriseToExplicitlyOwnBoards')) &&
        !_.isEmpty(enterprise) &&
        !me.isPersonalBoardOwnershipBannerDismissed()
      ) {
        container.append(
          this.topLevelView(PersonalBoardsOwnershipBanner, me, {
            enterpriseName: enterprise.name,
            idEnterprise: enterprise.id,
            ownDate: enterprise.ownDate,
          }).render().el,
        );
      } else if ((org = getOverdueOrganization(Auth.me()))) {
        container.append(
          this.topLevelView(OverdueBannerView, org, {
            modelCache: headerCache,
          }).render().el,
        );
      } else if (needBackupCodes(Auth.me())) {
        container.append(
          this.topLevelView(TwoFactorBackupsBannerView, me, {
            modelCache: headerCache,
          }).render().el,
        );
      } else if (
        (locale = _.find(bannerLocales, (locale) =>
          Auth.me().shouldShowNewLanguageBannerFor(locale),
        ))
      ) {
        container.append(
          this.topLevelView(NewLocaleBannerView, me, {
            modelCache: headerCache,
            locale,
          }).render().el,
        );
      }

      // always try to add the enterprise deprovisioning banner, even if another banner is showing
      showEnterpriseDeprovisioningBanner(
        Auth.me(),
        headerCache,
        this.topLevelView.bind(this),
      );

      // always show enterprise notification banners, even if other banners are showing
      return showEnterpriseNotificationBanners(
        Auth.me(),
        headerCache,
        this.topLevelView.bind(this),
      );
    } else {
      if (currentModelManager.onAnyBoardView() && currentModel.isPublic()) {
        if (currentModel.isTemplate()) {
          return container.append(
            this.topLevelView(TemplateBannerView, currentModel, {
              modelCache: this.getCurrentModelCache(),
            }).render().el,
          );
        } else if (
          getLoggedOutHeaderExperiment() !==
          LoggedOutNavExperimentVariations.EXPERIMENT
        ) {
          return container.append(
            this.topLevelView(PublicBoardBannerView, currentModel, {
              modelCache: this.getCurrentModelCache(),
            }).render().el,
          );
        }
      }
    }
  }
};
